import { createComponent } from '@carvana/merch-components';

export const Banner = createComponent('section', {
  className:
    'mx-2xl mb-3xl mt-6xl flex flex-col items-center gap-xl rounded-xl bg-background-strong px-xl py-3xl sm:mx-3xl sm:mb-4xl sm:mt-8xl sm:p-4xl md:w-[1272px] md:gap-2xl md:px-9xl md:py-7xl'
});

export const BannerTitle = createComponent('div', {
  className:
    'max-w-[700px] text-center text-decorative-ev t-heading-2xl md:t-heading-4xl'
});

export const BannerSubtitle = createComponent('div', {
  className: 'text-center text-text-inverse t-body-md'
});
